
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { AggregateCriteria, ExecutionResult, IAggregate, ICardData, PerformActionParams, StringHolder } from "@tylertech/tyler-api-types";

/**
 * AggregateService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class AggregateService {
    private readonly $apiService = inject(ApiService);
    
    GetAggregateCriterias(): Promise<AggregateCriteria[]> {
        return this.$apiService.sendAuth("IAggregateService/GetAggregateCriterias");
    }
    GetAggregatesForProvider(sHolder: StringHolder): Promise<ExecutionResult<IAggregate[]>> {
        return this.$apiService.sendAuth("IAggregateService/GetAggregatesForProvider", sHolder);
    }
    GetCardDatas(aggregate: IAggregate): Promise<ExecutionResult<ICardData[]>> {
        return this.$apiService.sendAuth("IAggregateService/GetCardDatas", aggregate);
    }
    GetWidgetAggregates(): Promise<ExecutionResult<IAggregate[]>> {
        return this.$apiService.sendAuth("IAggregateService/GetWidgetAggregates");
    }
    PerformCardAction(performActionParams: PerformActionParams): Promise<ExecutionResult<ICardData>> {
        return this.$apiService.sendAuth("IAggregateService/PerformCardAction", performActionParams);
    }
}
